export enum Breakpoints {
  MOBILE = 'base',
  TABLET = 'sm',
  DESKTOP = 'md',
}
